export default __webpack_public_path__ + "static/media/mockup16.7af6247a.jpg";